import { render, staticRenderFns } from "./profile-edit-contact-form.vue?vue&type=template&id=548e9bfa&scoped=true&"
import script from "./profile-edit-contact-form.vue?vue&type=script&lang=js&"
export * from "./profile-edit-contact-form.vue?vue&type=script&lang=js&"
import style0 from "./profile-edit-contact-form.vue?vue&type=style&index=0&id=548e9bfa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548e9bfa",
  null
  
)

export default component.exports